





























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { ComorbidadeProps } from '@/types/interfaces/Comorbidades'
import BackofficeComorbidadesStore from '../Store/BackofficeComorbidadeStore'

@Component
export default class ComponentModalUpsertComorbidade extends Vue {
  saveLoading: boolean = false
  newComorbidade: ComorbidadeProps = {} as ComorbidadeProps
  comorbidadesDefault = [
    '174d0e43-b50e-4bc3-a5bc-0e90c60d7af9',
    '3412fcd1-40ef-4f2c-84ea-7c969084172f',
    '5a8302e9-4329-419a-81e0-cf5e52037d83',
    '4ee3e9c5-ba81-4dd0-af07-d64e4b689f68',
    '78467483-db5f-485e-b556-e3a226811259',
    'de598e1c-1ee2-4499-b1d8-e69adda46a61',
    '0e7ae83a-cb27-462b-8442-eee0c1995414',
  ]

  get getBackofficeComorbidadesStore() {
    return getModule(BackofficeComorbidadesStore, this.$store)
  }

  get modal() {
    return this.getBackofficeComorbidadesStore.modal
  }

  set modal(value) {
    this.getBackofficeComorbidadesStore.setModal(value)
  }

  get comorbidadeSelected() {
    return this.getBackofficeComorbidadesStore.comorbidadeSelected
  }

  get notEditedYet() {
    if (this.modal.mode !== 'EDIT') return false

    return (
      this.newComorbidade.descricao === this.comorbidadeSelected.descricao
      && this.newComorbidade.hisId === this.comorbidadeSelected.hisId
      && this.newComorbidade.status === this.comorbidadeSelected.status
    )
  }

  get modalTitle() {
    const titles = {
      EDIT: 'Editar Comorbidade',
      CREATE: 'Criar Comorbidade',
    }
    return titles[this.modal.mode]
  }

  get buttonIcon() {
    const icons = {
      EDIT: 'edit',
      CREATE: 'save',
    }
    return icons[this.modal.mode]
  }

  formState = {
    valid: true,
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  closeModal() {
    this.getBackofficeComorbidadesStore.clearComorbidadeSelected()
    this.modal = { isOpen: false, mode: 'CREATE' }
  }

  async save() {
    const isValid = (
      this.$refs.formRef as Vue & { validate: () => boolean }
    ).validate()
    if (isValid) {
      this.saveLoading = true
      const response = await this.getBackofficeComorbidadesStore.upsertComorbidade(
        this.newComorbidade,
      )
      if (response.success) {
        this.saveLoading = false
        const toastMessage = this.modal.mode === 'CREATE'
          ? 'Comorbidade criada com sucesso!'
          : 'Comorbidade editada com sucesso!'
        EventBus.$emit('setSnackbar', {
          show: true,
          text: toastMessage,
          icon: 'done',
          color: '#2E7D32',
        })
        this.closeModal()
        this.getBackofficeComorbidadesStore.getComorbidadesByHospitalId()
      } else {
        this.saveLoading = false
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message || 'Erro ao salvar comorbidade.',
          icon: 'warning',
          color: '#C62828',
        })
      }
    }
  }

  @Watch('comorbidadeSelected')
  onComorbidadeSelectedChange(newValue: ComorbidadeProps) {
    this.newComorbidade = { ...newValue }
  }
}
